import React from "react"
import DropdownBlock from "../block/DropdownBlock"

const LanguageSelector = () => {
    return (
        <DropdownBlock disabled selected={<p>Русский</p>} list={[<p key={"uz"}>Ozbekcha</p>]} onSelect={() => console.log("Selected")} />
    )
}

export default LanguageSelector